<template>
  <li
    :class="[
      'menu-wrapper-item',
      icon ? 'd-flex menu-wrapper-item-icon' : '',
      { 'menu-border': seperatorBottom },
      { 'disabled-item': disabledItem },
      { 'invisible-item': !visible },
      { 'hide-visiable': hideVisiable },
      dbOptionHeight,
    ]"
    role="menuitem"
    tabindex="-1"
    @click="emitClick"
    @keyup.enter="emitClick"
    @keyup.space="emitClick"
  >
    <template v-if="icon">
      <div :class="['menu-item-ic', icon]"></div>
      <div class="menu-item-content"><slot></slot></div>
    </template>
    <slot v-else></slot>
  </li>
</template>

<script>
export default {
  props: {
    icon: {
      type: [Array, String],
      default: null,
    },
    seperatorBottom: {
      type: Boolean,
      default: false,
    },
    // disabled 1 item theo trạng thái nào đó VD theo mode
    disabledItem: {
      type: [Boolean, Number],
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    hideVisiable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitClick() {
      this.$emit('menu-item-click');
    },
  },
  computed: {
    dbOptionHeight() {
      return 'heightoptionvalue' + parseInt(this.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-wrapper-item {
  &.disabled {
    pointer-events: none;
    opacity: 0.2;
  }
  &.menu-border {
    border-bottom: 1px solid #dadada;
  }
  &.menu-wrapper-item-icon {
    padding: 0 16px 0 6px !important;
    white-space: nowrap;
  }
  .menu-item-ic {
    margin-right: 8px;
  }
  &.disabled-item {
    pointer-events: none;
    color: #afafaf;
  }
  &.invisible-item {
    display: none;
  }
  &.hide-visiable {
    display: none;
  }
}
.heightoptionvalue1 {
  height: $input-height-custom-small-no-border;
  font-size: $font-size-custom-small !important;
  line-height: $input-height-custom-small-no-border !important;
}

.heightoptionvalue2 {
  height: $input-height-custom-big-no-border;
  font-size: $font-size-custom-big !important;
  line-height: $input-height-custom-big-no-border !important;
}
</style>
